// extracted by mini-css-extract-plugin
module.exports = {"mobilePresenterFeedsHolder":"MobilePresenterFeeds_mobilePresenterFeedsHolder__3eikH","fakePresenterItem":"MobilePresenterFeeds_fakePresenterItem__PfyQv"};